// extracted by mini-css-extract-plugin
export default {"tooltip":"T4H6La","fadein":"WRcvbb","tooltipAfter":"HGA3qL","tooltipBefore":"bgtQqq"};